import React, { useContext } from "react";

import { PrivateContext } from "lib/context";
// eslint-disable-next-line import/no-cycle
import { storageHelper } from "lib/helpers";
// eslint-disable-next-line import/no-cycle
import { SkeletonAnnotated } from "lib/components";
// eslint-disable-next-line import/no-cycle
import { withErrorBoundary } from "lib/hoc";
import constant from "lib/constant/constant";
// eslint-disable-next-line import/no-cycle
import OperatorRate from "./subFeatures/rate/rate";

const { userKey } = constant;
const { operator } = userKey;

const CurrencyRateSetting = () => {
  const { isLoading } = useContext(PrivateContext);
  const currentUserRole = storageHelper.get("userRole");
  const getComponent = (role) => {
    if (isLoading) {
      return <SkeletonAnnotated />;
    }
    if (role === operator) {
      return <OperatorRate />;
    }
    return null;
  };
  const exchangeComponent = getComponent(currentUserRole);
  return exchangeComponent;
};

export default withErrorBoundary(CurrencyRateSetting);
